import { FunctionComponent } from 'react';
import {
  AuthContainer,
  AuthPrimaryButton,
} from '@client/components/AuthComponents';
import { useNavigate } from 'react-router';

export const NotFound: FunctionComponent = () => {
  const navigate = useNavigate();

  const handleReturnToHome = () => {
    navigate('/');
  };

  return (
    <AuthContainer title="404 - Page Not Found">
      <div className="flex flex-col items-center justify-center space-y-6 pt-4 text-gray-800">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-yellow-100">
          <svg
            className="h-8 w-8 text-yellow-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
            />
          </svg>
        </div>
        <p className="text-center text-base">
          The page you're looking for doesn't exist.
        </p>
        <div className="space-y-3">
          <AuthPrimaryButton
            title="Return to Home"
            onClick={handleReturnToHome}
            className="w-full py-6 text-base"
          />
        </div>
      </div>
    </AuthContainer>
  );
};
